import { driver } from "driver.js";
import "driver.js/dist/driver.css";

export function startTourEmpresa(navigate, uid) {
  const profilePath = `/perfil/${uid}`;

  if (window.location.pathname === profilePath) {
    setTimeout(() => startEmpresaTourSteps(), 400);
  } else {
    sessionStorage.setItem("aw_pending_tour", "empresa");
    navigate(profilePath);
  }
}

export function startEmpresaTourSteps() {
  let menuClickHandler = null;
  let optionClickHandler = null;

  const cleanupMenuListener = () => {
    const btn = document.querySelector('[data-tour-id="perfil-menu-trigger"]');
    if (btn && menuClickHandler) {
      btn.removeEventListener("click", menuClickHandler);
      menuClickHandler = null;
    }
  };

  const cleanupOptionListener = () => {
    const opt = document.querySelector('[data-tour-id="menu-crear-empresa"]');
    if (opt && optionClickHandler) {
      opt.removeEventListener("click", optionClickHandler);
      optionClickHandler = null;
    }
  };

  const driverObj = driver({
    showProgress: true,
    nextBtnText: "Siguiente →",
    prevBtnText: "← Anterior",
    doneBtnText: "¡Listo!",
    progressText: "{{current}} de {{total}}",
    allowClose: false,
    onDestroyStarted: () => {
      cleanupMenuListener();
      cleanupOptionListener();
      driverObj.destroy();
    },
    steps: [
      {
        element: '[data-tour-id="perfil-menu-trigger"]',
        popover: {
          title: "⋯ Menú de opciones",
          description:
            "Haz clic en este botón para abrir el menú de opciones de tu perfil.",
          side: "bottom",
          align: "end",
          showButtons: ["close"],
        },
        onHighlightStarted: () => {
          const btn = document.querySelector('[data-tour-id="perfil-menu-trigger"]');
          if (!btn) return;
          menuClickHandler = () => {
            cleanupMenuListener();
            setTimeout(() => driverObj.moveNext(), 400);
          };
          btn.addEventListener("click", menuClickHandler);
        },
        onDeselected: () => {
          cleanupMenuListener();
        },
      },
      {
        element: '[data-tour-id="menu-crear-empresa"]',
        popover: {
          title: "🏢 Crear Empresa",
          description:
            "Haz clic aquí para iniciar el proceso de creación de tu empresa y empezar a publicar eventos.",
          side: "left",
          align: "start",
          showButtons: ["close"],
        },
        onHighlightStarted: () => {
          const opt = document.querySelector('[data-tour-id="menu-crear-empresa"]');
          if (!opt) return;
          optionClickHandler = () => {
            cleanupOptionListener();
            driverObj.destroy();
          };
          opt.addEventListener("click", optionClickHandler);
        },
        onDeselected: () => {
          cleanupOptionListener();
        },
      },
    ],
  });

  driverObj.drive();
}
